import { render, staticRenderFns } from "./PollutedWastewater.vue?vue&type=template&id=2b025ff1&scoped=true&"
import script from "./PollutedWastewater.vue?vue&type=script&lang=js&"
export * from "./PollutedWastewater.vue?vue&type=script&lang=js&"
import style0 from "./PollutedWastewater.vue?vue&type=style&index=0&id=2b025ff1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b025ff1",
  null
  
)

export default component.exports